angular.module('impactx.sapconfig').controller('SAPEKGListController', [
    'selectedListItems',
    SAPEKGListController]);

function SAPEKGListController(selectedListItems) {
    var ctrl = this;

    this.getDetailLink = function() {
        return "sapekg/" + selectedListItems.getFirstSelectedId();
    };

    var buttonDefinition = [
        {label: "details", linkFunction: ctrl.getDetailLink, type:'link', condition:  selectedListItems.isSingleSelection, process: 'SAPEKG'}
    ];

    this.meta = {
        rowTemplate: 'modules/sapconfig/templates/sapekglist.row.tmpl.html',
        isSelectAble: true,
        endpoint: '/sapconfiguration/ekglist',
        ctrl: this,
        id: "sapekglist",
        mainAction : {id:"new", link: "#/sapekg/0", icon:"mdi-plus"},
        buttonDefinition: buttonDefinition
    };
    this.getMeta = function() {
        return this.meta;
    };
}